var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n        "+_vm._s(_vm.$t("Today's Calendar"))+"\n    ")]),_vm._v(" "),(typeof _vm.fcEvents === 'object')?_c('div',{staticClass:"card-block"},[_c('full-calendar',{attrs:{"config":_vm.fcConfig,"events":_vm.fcEvents}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef79074","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/customer/TrainerProfileCalendar.vue
// module id = null
// module chunks = 